import { AgenciesActions } from '@/store/agencies';
import { CustomerActions } from '@/store/customer';
import { FormsActions, FormsSelector } from '@/store/forms';
import { Stack } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { StepperHeader, StepperSideImage, Steps } from './subComponents';
export const SalesWizard = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const formId = 'steps';
    const formValues = useSelector((state) => FormsSelector.getFormValues(state, formId));
    const { step = 0 } = formValues;
    const handleLoadCustomer = async () => {
        const queryParams = new URLSearchParams(location.search);
        const id = queryParams.get('id');
        if (id) {
            const customerReq = await dispatch(CustomerActions.fetchCustomerAsync({ id }));
            if (CustomerActions.fetchCustomerAsync.fulfilled.match(customerReq)) {
                const { email, firstName, lastName, company: organizationName, companyType: organizationType, grantExperience, bandwidth, companyDescription: organizationDescription, fundingStrategy, } = customerReq.payload;
                dispatch(FormsActions.setValue({
                    id: 'userForm',
                    email,
                    firstName,
                    lastName,
                    organizationName,
                    organizationType,
                    grantExperience,
                    bandwidth,
                    organizationDescription,
                    fundingStrategy,
                }));
                dispatch(FormsActions.setValue({ id: 'steps', step: 2 }));
            }
        }
    };
    useEffect(() => {
        dispatch(AgenciesActions.fetchAgenciesAsync());
        handleLoadCustomer().catch();
    }, [location]);
    return (React.createElement(Stack, { minHeight: "100vh", mt: 3, alignItems: "center" },
        React.createElement(StepperHeader, { step: step }),
        React.createElement(Steps, { step: step }),
        React.createElement(StepperSideImage, null)));
};
